(() => {
  const firstSentence = text => text.match(/^.*?[.!?](?:\s|$)/)?.[0].trim() || text;
  function takeaway(title, text, a) {
    const commercial = a.use === 'commercial';
    const low = ['under3000', 'b3000_4994'].includes(a.budget);
    if (title === 'Where it can go') return commercial
      ? 'Call our commercial team to choose the right indoor or outdoor location for your business.'
      : 'You can use our residential plunge indoors or outdoors, with a 28.5-inch width and no seasonal winterizing.';
    if (title === 'Outdoor use' && (a.climate_cold === 'belowminus20' || a.climate_hot === 'over120')) return 'Your outdoor temperatures are outside our -20°F to 120°F range, so call us before ordering.';
    if (title === 'Outdoor use') return a.cover === 'covered'
      ? 'Your covered spot is ideal for outdoor plunging all year, with no winterizing.'
      : 'You can plunge outdoors all year, but your spot needs shade from prolonged direct sunlight.';
    if (title === 'Indoor use') return commercial
      ? 'At 28.5 inches wide, our commercial plunge fits through a standard doorway with no external chiller hoses.'
      : 'Our residential plunge is leak-free by design and fits through a standard doorway at 28.5 inches wide.';
    if (title === 'Delivery and stairs') return 'Standard delivery is curbside; stairs require carrying with straps, or call us for a white-glove delivery quote.';
    if (title === 'Body fit') return 'The interior is 54 × 21 × 24 inches, with recommended limits of 6 feet 6 inches and 280 lbs.';
    if (title === 'Height fit') return a.height === 'over64'
      ? 'Your height is above our recommended 6-foot-6-inch limit, so call us before ordering.'
      : a.height === 'under52' ? 'Under 5 feet 2 inches? Call us to discuss a comfortable seated position before ordering.'
      : 'Your height is within our recommended range.';
    if (title === 'Weight fit') return a.weight === 'over250'
      ? 'At 250+ lbs, call us before ordering to confirm fit; our recommended weight limit is 280 lbs.'
      : 'Your weight is within our recommended 280-lb limit.';
    if (title === 'Temperature') return a.temperature === 't32'
      ? 'Our plunge reaches your 32°F target and can make ice.'
      : a.temperature === 'unsure' ? 'Choose your temperature when you’re ready; our plunge goes all the way down to 32°F and can make ice.'
      : 'You can start at your preferred temperature and go down to 32°F as your preferences change.';
    if (title === 'Power') return commercial ? 'Call our commercial team to confirm the right power supply for your business.' : 'Plug into a standard 110V outlet: just 2.36 amps, no dedicated circuit, and a plug-in GFCI included.';
    if (title === 'U.S.-based support' || title === 'Poor support') return Number(a.support) > 5
      ? 'Real people in the U.S. answer during business hours; call us and put our support to the test.'
      : 'When you need help, real people in the U.S. answer the phone and return after-hours messages within one business day.';
    if (title === 'Budget' || title === 'Price') return commercial
      ? 'Call our commercial team for pricing for your business.'
      : low ? 'The residential model starts at $4,995, above your budget; call us for specials, promotions and scratch-and-dent availability.'
      : a.budget === 'unsure' ? 'The residential model starts at $4,995 with built-in cooling, 32°F water and live U.S.-based support.'
      : 'Your budget puts the $4,995 residential model and its all-in-one features within reach.';
    // Recognized write-ins use the same grounded answer as the assessment.
    // Replace conversational openers that do not contain the actual answer.
    if (/^(Live support matters|Even if phone support|You want support)/.test(text)) return 'Real people in the U.S. answer during business hours and return after-hours messages within one business day.';
    if (text.startsWith('Your question:') || text.startsWith('You wrote:')) return 'Call us about “' + (a.priority_other || '') + '” for a specific answer from a real person in the U.S.';
    return firstSentence(text);
  }
  function plan(fit, answers) {
    const groups = [
      {key:'priority', title:'What matters most to you', items:[]},
      {key:'placement', title:'Where your plunge will go', items:[]},
      {key:'body', title:'Your fit in the tub', items:[]},
      {key:'temperature', title:'Your temperature and power', items:[]},
      {key:'support', title:'Your budget and support', items:[]}
    ];
    fit.summary.forEach(([title, text], index) => {
      const group = index === 0 ? 0 : ['Outdoor use','Indoor use','Where it can go','Delivery and stairs','Your climate'].includes(title) ? 1
        : ['Body fit','Height fit','Weight fit'].includes(title) ? 2 : ['Temperature','Power'].includes(title) ? 3 : 4;
      groups[group].items.push({title, takeaway:takeaway(title, text, answers), text});
    });
    return groups.filter(group => group.items.length);
  }
  function render(target, fit, answers, images) {
    const doc = target.ownerDocument;
    target.replaceChildren(...plan(fit, answers).map(group => {
      const section = doc.createElement('section'); section.className = 'fcp-fit-row';
      const media = doc.createElement('div'); media.className = 'fcp-fit-row__media';
      const image = doc.createElement('img'), source = images[group.key];
      image.src = source.src; image.alt = source.alt; image.loading = 'lazy'; image.width = 800; image.height = 800;
      media.append(image);
      const content = doc.createElement('div'); content.className = 'fcp-fit-row__content';
      const heading = doc.createElement('h3'); heading.textContent = group.title; content.append(heading);
      group.items.forEach(item => {
        const details = doc.createElement('details'); details.className = 'fcp-fit-answer';
        const summary = doc.createElement('summary');
        const label = doc.createElement('span'); label.className = 'fcp-fit-answer__label'; label.textContent = item.title;
        const lead = doc.createElement('span'); lead.className = 'fcp-fit-answer__takeaway'; lead.textContent = item.takeaway;
        const icon = doc.createElement('span'); icon.className = 'fcp-fit-answer__icon'; icon.textContent = '+'; icon.setAttribute('aria-hidden','true');
        summary.append(label, lead, icon); details.append(summary);
        const body = doc.createElement('div'); body.className = 'fcp-fit-answer__body';
        const paragraph = doc.createElement('p'); paragraph.textContent = item.text; body.append(paragraph); details.append(body);
        content.append(details);
      });
      section.append(media,content); return section;
    }));
  }
  globalThis.FcpFitResults = {plan, render};
})();
